import React from 'react';
import {View, StyleSheet} from 'react-native';
import OffersErrorView from 'src/components/elements/offers/OffersErrorView';
import Localized from 'src/constants/AppStrings';

interface NoConnectivityViewProps {
  onSettingsPress: () => void;
}

export const NoConnectivityView: React.FC<NoConnectivityViewProps> = ({
  onSettingsPress,
}) => (
  <View style={styles.container}>
    <OffersErrorView
      errorText={Localized.Errors.add_credit_network_error}
      buttonLabel={Localized.Buttons.go_to_settings}
      onPress={onSettingsPress}
      viewStyle={styles.errorView}
      isCenter
    />
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  errorView: {
    justifyContent: 'center',
  },
});
